<template>
	<div class="chat-system-box">
		<el-container class="chat-system-layout">
			<el-header height="50px" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
				<span>{{ chat.showName }}</span>
			</el-header>
			<el-main class="main" id="chatScrollBox" @scroll="onScroll">
				<div v-for="(msgInfo, idx) in chat.messages" :key="messageKey(msgInfo)">
					<div v-if="idx >= showMinIdx">
						<div class="message-box" @click="onClickMessage(msgInfo)"
							v-if="msgInfo.type == $enums.MESSAGE_TYPE.SYSTEM_MESSAGE">
							<div class="title">{{ msgInfo.title }}</div>
							<asset-image class="cover" v-if="msgInfo.coverUrl" :src="msgInfo.coverUrl" :strict="true" />
							<div class="intro">{{ msgInfo.intro }}</div>
							<div class="bottom-bar">查看详情</div>
						</div>
						<div class="message-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">
							{{ $date.toTimeText(msgInfo.sendTime) }}
						</div>
					</div>
				</div>
			</el-main>
			<chat-system-content ref="contentRef"></chat-system-content>
		</el-container>
	</div>
</template>

<script>
import ChatSystemContent from './ChatSystemContent';
import AssetImage from '../common/AssetImage.vue';

const SYSTEM_CHAT_LOCAL_HISTORY_PAGE_SIZE = 30;

export default {
	name: "chatSystem",
	components: {
		AssetImage,
		ChatSystemContent
	},
	props: {
		chat: {
			type: Object
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo || {};
		}
	},
	data() {
		return {
			showMinIdx: 5,
			readRequest: null
		}
	},
	methods: {
		messageKey(message) {
			return message.id || message.localId || message.tmpId ||
				`${message.sendId || 0}:${message.sendTime || 0}:${message.type || 0}`;
		},
		loadSystemMessages() {
			const chat = this.chatStore.findChat(this.chat);
			if (!chat || !this.$db || typeof this.$db.findMessagesBefore !== 'function') {
				return Promise.resolve(0);
			}
			const convKey = typeof this.$db.buildConversationKey === 'function'
				? this.$db.buildConversationKey(chat.type, chat.targetId)
				: `${chat.type}-${chat.targetId}`;
			return this.$db.findMessagesBefore(convKey, Number.MAX_SAFE_INTEGER, SYSTEM_CHAT_LOCAL_HISTORY_PAGE_SIZE).then((messages) => {
				if (!Array.isArray(messages) || messages.length === 0) {
					return 0;
				}
				messages.forEach((msg) => {
					msg.selfSend = msg.sendId == this.mine.id;
				});
				return this.chatStore.mergeHistoryMessages(messages, chat, { source: 'local-db-page' });
			}).catch((error) => {
				console.warn('加载系统消息失败', error);
				return 0;
			});
		},
		onClickMessage(msgInfo) {
			this.$refs.contentRef.show(msgInfo.id, msgInfo.title);
		},
		readedMessage() {
			if (this.chat.unreadCount == 0 || this.readRequest) {
				return;
			}
			const readChat = this.chat;
			const maxSeqNo = (readChat.messages || []).reduce((max, message) =>
				message && message.seqNo ? Math.max(max, Number(message.seqNo) || 0) : max, 0);
			if (!maxSeqNo) return;
			this.readRequest = this.$http({
				url: `/message/system/readed?maxSeqNo=${maxSeqNo}`,
				method: 'put'
			}).then(() => {
				this.chatStore.advanceReadCursor(readChat, maxSeqNo);
				const latestSeqNo = (readChat.messages || []).reduce((max, message) =>
					message && message.seqNo ? Math.max(max, Number(message.seqNo) || 0) : max, 0);
				if (latestSeqNo <= maxSeqNo) this.chatStore.resetUnreadCount(readChat);
			}).finally(() => {
				this.readRequest = null;
			});
		},
		scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
			});
		},
		onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			if (scrollTop < 30) { // 在顶部,不滚动的情况
				// 多展示5条信息
				this.showMinIdx = this.showMinIdx > 5 ? this.showMinIdx - 5 : 0;
			}

		},
	},
	watch: {
		chat: {
			async handler(newChat, oldChat) {
				await this.loadSystemMessages();
				this.readedMessage();
				this.scrollToBottom();
				// 初始状态只显示5条消息
				let size = this.chat.messages.length;
				this.showMinIdx = size > 5 ? size - 5 : 0;
			},
			immediate: true
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
	}
}
</script>

<style lang="scss" scoped>
.chat-system-box {
	display: flex;
	flex: 1;
	flex-direction: column;
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 0;
	overflow: hidden;
	background: var(--im-background-secondary);

	.chat-system-layout {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-height: 0;
	}

	.main {
		flex: 1;
		min-height: 0;
		overflow-y: auto;
		overflow-x: hidden;
		background: var(--im-background-secondary);
		margin: 0 3px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.message-box {
			width: 400px;
			background-color: var(--im-background);
			text-align: left;
			border-radius: 3%;
			margin: 15px;
			padding: 5px 20px;
			cursor: pointer;

			.title {
				text-align: center;
				font-size: 18px;
				white-space: nowrap;
				overflow: hidden;
				margin: 10px 20px;
				font-weight: 600;
			}

			.cover {
				width: 100%;
				height: 200px;
				object-fit: cover;
				border-radius: 3px;
			}

			.intro {
				padding: 8px;
				font-size: 16px;
				border-bottom: 1px solid var(--im-border-light);
				overflow-wrap: break-word
			}

			.bottom-bar {
				font-size: 14px;
				padding: 8px;
				text-align: left;
				color: var(--im-color-primary);
			}
		}

		.message-tip {
			line-height: 20px;
			font-size: var(--im-font-size-small);
			color: var(--im-text-color-light);
		}
	}
}
</style>
